<template>
  <div v-loading="loading">
    <el-table
      v-if="tableConfig"
      :key="tableKey"
      :data="declutters.data"
      style="width: 100%"
      row-key="id"
      highlight-current-row
      :row-class-name="'pointer-row'"
      @sort-change="handleSortChange"
      @row-click="(row) => $router.replace('/processes/declutters/view/' + row.id)"
    >
      <component
        :is="column.value"
        v-for="column in tableConfig.columns"
        :key="column.value"
      />
      <el-table-column
        fixed="right"
        label=""
        width="70"
        style="text-align: right;"
      >
        <template
          slot="header"
          slot-scope="scope"
        >
          <table-settings
            v-if="tableConfig"
            :config="tableConfig"
            :allcolumns="allColumns"
            :labels="labels"
            store-module="declutter"
            :options="['settings', 'export']"
          />
        </template>
        <template
          slot-scope="scope"
        >
          <Actions :declutter="scope.row" />
        </template>
      </el-table-column>
    </el-table>
    <div class="el-card-footer">
      <el-pagination
        background
        :current-page.sync="currentPage"
        :page-sizes="[20, 50, 100, 200]"
        :page-size="declutters.per_page"
        layout="total, prev, pager, next"
        :total="declutters.total"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
  import Actions from './Actions';
  import TableSettings from '../../TableSettings';
  import columns, { allColumns, labels } from './columns';

  export default {
    components: {
      Actions,
      TableSettings,
      ...columns,
    },
    data() {
      return {
        labels,
        allColumns,
        tableKey: 0,
        currentPage: 1,
        currentSort: {
          prop: 'created_at',
          order: 'asc',
        },
      };
    },
    computed: {
      declutters() {
        return this.$store.getters['declutter/declutters'];
      },
      tableConfig() {
        return JSON.parse(JSON.stringify(this.$store.getters['declutter/tableConfig']));
      },
      loading() {
        return this.$store.getters['declutter/loading'];
      },
    },
    watch: {
      tableConfig() {
        this.tableKey++;
      },
    },
    async mounted() {
      this.$store.commit('declutter/setFilterString', '');
      this.$store.commit('declutter/setCurrentPage', this.currentPage);
      this.$store.commit('declutter/setSorting', this.currentSort);
      await this.$store.dispatch('declutter/fetchAll');
    },
    methods: {
      handleCurrentChange(val) {
        this.$store.commit('declutter/setCurrentPage', val);
        this.$store.dispatch('declutter/fetchAll');
      },
      handleSortChange({ column, prop, order }) {
        if (column.sortable === 'custom') {
          this.$store.commit('declutter/setSorting', { prop, order });
          this.$store.dispatch('declutter/fetchAll');
        }
      },
    },
  };
</script>


